const state = {
  userInfo: null,
  token: localStorage.getItem('token') || null,
  isLoggedIn: false
};

const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
    state.isLoggedIn = !!userInfo;
  },
  SET_TOKEN(state, token) {
    state.token = token;
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  },
  LOGOUT(state) {
    state.userInfo = null;
    state.token = null;
    state.isLoggedIn = false;
    localStorage.removeItem('token');
  }
};

const actions = {
  login({ commit }, { userInfo, token }) {
    commit('SET_USER_INFO', userInfo);
    commit('SET_TOKEN', token);
  },
  logout({ commit }) {
    commit('LOGOUT');
  }
};

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  userInfo: state => state.userInfo,
  token: state => state.token
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};